import styled from "styled-components";
import { Box } from "@similarweb/ui-components";

export const Container = styled(Box)`
    width: 100%;
    height: fit-content;
    .is-sortable {
        .headerCell-sortDirection {
            display: none;
        }
    }
    .is-sorted {
        .headerCell-sortDirection {
            display: block;
        }
    }
    .swReactTableHeaderCell {
        .right-align {
            display: flex;
            justify-content: flex-end;
            width: 100%;
        }
    }
`;
